<!-- Add Discounted Period Modal  -->
<p-dialog [(visible)]="showDiscountPeriodPopup" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '670px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <div class="surface-0 sticky left-0 top-0 w-full px-3 py-2 flex align-items-center justify-content-between border-bottom-1 border-300">
            <h2 class="mb-0 text-sm font-bold flex align-items-center">
                {{'FREEDISCOUNT.ADD_FREE_DISCOUNT' | translate}}
                  <ng-container *ngIf="clientDetails.image;else noImage">
                    <p-avatar [image]="clientDetails.image" shape="" styleClass="mx-2"></p-avatar>
                  </ng-container>
                  <ng-template #noImage>
                    <p-avatar [label]="client2LetterName(clientDetails.full_name) | titlecase | shortName" shape="" styleClass="mx-2"></p-avatar>
                  </ng-template>
                <span class="text-primary cursor-pointer">{{clientDetails.full_name}}</span>
            </h2>
            <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()"></div>
        </div>
        <!-- Header -->

        <!-- Message -->
        <div class="-my-3">
            <p-message severity="info" styleClass="relative" aria-label="free-discount-limitation-message">
                {{'FREEDISCOUNT.LIMITATION' | translate}}
            </p-message>
             
        </div>
            <!-- Message -->

        <div class="p-3">
            <div class="p-buttonset">
                <p-button styleClass="text-sm white-space-nowrap border-right-1 border-white" icon="fa fa-percent" [label]="'FREEDISCOUNT.BTN_BY_STAFF' | translate"></p-button>
            </div>
        </div>

        <form [formGroup]="discountedPeriodForm">
        <!-- Modal Content -->
        <p-table [value]="discountedPeriods" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th class="surface-100">
                        <span class="py-1 text-xs text-600 white-space-nowrap">{{'FREEDISCOUNT.BILLING_CYCLE' | translate}}</span>
                    </th>
                    <th class="surface-100">
                        <span class="py-1 text-xs text-600 white-space-nowrap">{{'FREEDISCOUNT.RECURRING_CHARGE' | translate}}</span>
                    </th>
                    <th class="surface-100">
                        <span class="py-1 text-xs text-600 white-space-nowrap">{{'FREEDISCOUNT.DISCOUNT' | translate}}</span>
                    </th>
                    <th class="surface-100">
                        <span class="py-1 text-xs text-600 white-space-nowrap"></span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-discountedPeriod let-i="index">
                <tr class="text-sm">
                    <td class="py-3 white-space-nowrap">
                        <p-button icon="fa fa-angle-down" [label]="discountedPeriod.get('discountAcucrence').value ? (discountedPeriod.get('discountAcucrence').value.occurance_start_date | datetimeformat :'d MMM yy' ) : 'Select...'" 
                        iconPos="right" styleClass="surface-0 p-button-outlined border-300 ml-2 text-600 text-sm w-8rem" (click)="selectBillingCycle.toggle($event)"
                        [ngClass]="{ 'ng-invalid ng-dirty': discountedPeriod.get('discountAcucrence').invalid && discountedPeriod.get('discountAcucrence').touched }"></p-button>
                        <p-popover #selectBillingCycle styleClass="overflow-hidden right-0 text-sm w-7rem">
                         <ng-template #content>
                            <ul *ngFor="let billingCycle of getOccurences" class="list-none -m-4 px-0 py-2 text-sm text-600">
                                <li (click)="selectBillingCycle.toggle($event); setAccurence(discountedPeriod, billingCycle)" class="cursor-pointer hover:surface-300 py-2 px-3">{{ billingCycle.occurance_start_date | datetimeformat :'d MMM yy'}}</li>
                            </ul>
                        </ng-template>
                        </p-popover>
                      </td>
                    <td class="py-3 white-space-nowrap"><strong>{{ discountedPeriod.get('discountedAmount').value | currencyformat}}</strong></td>
                    <td class="py-3 white-space-nowrap">
                        <div class="flex">

                            <!-- <input type="number" class="w-6rem text-sm" pInputText [formControl]="discountedPeriod.get('discountValue')"
                              [ngClass]="{ 'ng-invalid ng-dirty': discountedPeriod.get('discountValue').invalid || discountedPeriod.get('discountValue').errors}"
                              (blur)="calculateDiscount(discountedPeriod.get('discountTotalAmount'),discountedPeriod.get('discountValue'), discountedPeriod.get('discountPercent'))"
                              placeholder="Value" /> -->
                              <div class="p-inputgroup w-5rem ml-3">
                              <p-inputNumber
                              mode="decimal"
                              [minFractionDigits]="2"
                              [maxFractionDigits]="2"
                              [formControl]="discountedPeriod.get('discountValue')"
                              [ngClass]="{ 'ng-invalid ng-dirty': discountedPeriod.get('discountValue').invalid || discountedPeriod.get('discountValue').errors}"
                              styleClass="w-5rem text-sm"
                              (onBlur)="calculateDiscount(discountedPeriod.get('discountTotalAmount'),discountedPeriod.get('discountValue'), discountedPeriod.get('discountPercent'),discountedPeriod.get('discountedAmount'))">
                               </p-inputNumber>
                              </div>

                            <div class="p-inputgroup w-7rem ml-3">
                                <span class="p-inputgroup-addon"><i class="fa fa-percent text-500"></i></span>
                                <p-inputNumber
                                [formControl]="discountedPeriod.get('discountPercent')"
                                styleClass="text-sm w-7rem"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                mode="decimal"
                                [ngClass]="{ 'ng-invalid ng-dirty': discountedPeriod.get('discountPercent').invalid && discountedPeriod.get('discountPercent').touched }"
                                (onBlur)="calculateAmount(discountedPeriod.get('discountTotalAmount'),discountedPeriod.get('discountValue'), discountedPeriod.get('discountPercent'),discountedPeriod.get('discountedAmount'))">
                               </p-inputNumber>
                            </div>
                        </div>
                    </td>
                    <!-- Add a button to remove the row -->
                    <td class="py-2 white-space-nowrap">
                        <p-button icon="fa fa-trash-alt" styleClass="p-button-text p-button-secondary" pTooltip="Remove" tooltipStyleClass="text-xs" (click)="removeDiscountedPeriod(i,discountedPeriod.get('discountAcucrence').value.occurance_start_date)"></p-button>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div class="surface-100 p-3 border-top-1 border-bottom-1 border-300">
            <p-button icon="fa fa-plus" [label]="'FREEDISCOUNT.BTN_ADD_MORE' | translate" styleClass="text-sm p-button-outlined surface-0" (click)="addDiscountedPeriod()"></p-button>
        </div>

        <div class="p-3">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'FREEDISCOUNT.DISCOUNT_REASON' | translate}}</label>
            <textarea pInputTextarea class="w-full text-sm h-4rem" [placeholder]="'FREEDISCOUNT.PLACE_REASON' | translate" formControlName="discountReason"
              [ngClass]="{ 'ng-invalid ng-dirty': discountedPeriodForm.get('discountReason').invalid && discountedPeriodForm.get('discountReason').touched }">
            </textarea>
        </div>
        <!-- Modal Content -->

        <!-- Modal Footer -->
        <div class="surface-0 sticky left-0 bottom-0 w-full z-1 border-top-1 border-300 flex align-items-center justify-content-between p-3">
            <p-button label="Cancel" (click)="closePopup()" styleClass="text-sm p-button-text"></p-button>
            <p-button [disabled]="!isDiscountedPeriodsValid() || !discountedPeriodForm.valid" [loading]="btnLoading | async" (click)="onSubmit()" [label]="'FREEDISCOUNT.BTN_APPLY' | translate" styleClass="text-sm"></p-button>
        </div>
        <!-- Modal Footer -->
    </form>
    </ng-template>
</p-dialog>
<!-- Add Discounted Period Modal -->
